angular.module('SpidApp')

.factory('VacationDecorator',
		['Cash',
function (Cash) {
	var VacationDecorator = function (vacation) {
		vacation.dateStartLocaleString = new Date(vacation.dateStart).toLocaleString()

		if (vacation.dateEnd) {
			vacation.dateEndLocaleString = new Date(vacation.dateEnd).toLocaleString()
			
			vacation.amountStop = Cash.cumulate(vacation.state.bills, vacation.state.coins)
			
			vacation.isBalanced = ( (vacation.amountStop) - (vacation.amountStart + vacation.startTransfer) ) === 0;
		}
		
		return vacation
	}
	
	return VacationDecorator
}])

.factory('Vacation',
		['Cash',
function (Cash) {
	var Vacation = function (params) {
		params = params || {}

		this.id                = params.id
		this.idUser            = params.id_user
		this.idAgency          = params.agency_id
		this.dateStart         = params.date_start
		this.dateEnd 	       = params.date_end
		this.amountStart       = +params.amount_start
		this.endStateId        = params.end_state_id
		this.validated         = params.validated || false
		this.comment           = params.comment
		this.validationComment = params.validation_comment
		this.startTransfer     = params.start_transfer
		this.stopTransfer      = params.stop_transfer
		this.stop_total        = params.stop_total

		this.state = params.state ? Cash.reno(params.state) : params.state

		this._restangular = params
	}

	Vacation.prototype.isValidated = function () {
		return this.validated
	}

	Vacation.prototype.setValidated = function () {
		this.validated = true
	}

	Vacation.prototype.setUnvalidated = function () {
		this.validated = false
	}

	Vacation.status = {
		VALIDATED : 'VALIDATED',
		OPENED    : 'OPENED',
		CLOSED    : 'CLOSED'
	}
	Vacation.prototype.getStatus = function () {
		if (this.validated) {
			return Vacation.status.VALIDATED
		} else {
			if (!this.dateEnd) {
				return Vacation.status.OPENED
			} else {
				return Vacation.status.CLOSED
			}
		}

		throw 'Vacation::getStatus() - I shouldn\'t code'
	}

	Vacation.prototype.isValidated = function () {
		return this.getStatus() === Vacation.status.VALIDATED
	}
	Vacation.prototype.isOpened = function () {
		return this.getStatus() === Vacation.status.OPENED
	}
	Vacation.prototype.isClosed = function () {
		return this.getStatus() === Vacation.status.CLOSED
	}


	return Vacation
}])
